import { Component, EventEmitter, Input, Output } from '@angular/core';
import { asyncScheduler } from 'rxjs';
import { AppErrorMessageEvent } from '../../../core';

@Component({
  selector: 'error-panel',
  templateUrl: './error-panel.component.html',
  styleUrls: ['./error-panel.component.scss']
})
export class ErrorPanelComponent {  
    
  @Input() errorEvents : AppErrorMessageEvent[] = []

  // The selected error event
  @Input('errorEvent') set setSelected( e:AppErrorMessageEvent){
    this.errorEvent = e
    if ( !this.errorEvents ) {
      this.errorEvents = []
    }
    if ( this.errorEvents.findIndex(ee=>ee==e) == -1 )  {
      this.errorEvents.push(e)
    }
    console.dir(this.errorEvents)
  }
  
  @Output('errorDeleted') errorDeleted$ = new EventEmitter<AppErrorMessageEvent>()

  errorEvent: AppErrorMessageEvent
  bResetting = false
  removeError( e: AppErrorMessageEvent ) {
    const index = this.errorEvents.findIndex(error=>error==e)
    console.log(`removeError(index:${index})`)
    if ( index != -1 ) {
      const removedE = this.errorEvents.splice(index,1)
      this.errorDeleted$.emit(e)
      this.bResetting = true
      asyncScheduler.schedule(()=>this.bResetting=false)
    }
  }
}